<div fxLayout="row"
     fxLayoutGap="10px">
  <!-- <div fxLayout="row" fxLayoutGap="10px grid" fxLayoutAlign="space-around start"> -->
  <div class="plan-container"
       fxFlex="20">
    <div>
      <div class="fusion-text-2 price">
        <h2 style="--fontsize: 33; line-height: 1.5; --fontSize: 40;"
            data-fontsize="40"
            data-lineheight="60px">
          $0.00
        </h2>
        <p>
          <sup>
            USD
            <br>
            /mo
          </sup>
        </p>
      </div>
      <div class="fusion-title-2 title">
        <div>
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
        <span class="awb-title-spacer"></span>
        <h2 class="fusion-title-heading title-heading-center"
            style="margin:0;font-size:1em;--fontSize:35;line-height:1.14;">
          Free
        </h2>
        <span class="awb-title-spacer"></span>
        <div class="title-sep-container title-sep-container-right">
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
      </div>
      <div class="features fusion-text-3">
        <ul>
          <li aria-level="1">
            One (1) additional user- either associate or admin.
          </li>
          <li aria-level="1">
            Consultants: 3 at any one time.
          </li>
          <li aria-level="1">
            DICOM image disc upload and Cloud storage (medical imaging studies: (Limit 6 studies at any
            one time).
          </li>
          <li aria-level="1">
            Upload from Practice Management systems &amp; Desktop:
            <span style="color: #00a9d3;">
              Clio
              users only
            </span>
            .
          </li>
          <li aria-level="1">
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color);">
              ZOOM
              MEETINGS: 4/month.
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="plan-container"
       fxFlex="20">
    <div>
      <div id="silver"
           class="fusion-text-4 price"
           style="--awb-line-height:40px;">
        <h2 style="--fontsize: 33; line-height: 1.5; --fontSize: 40;"
            data-fontsize="40"
            data-lineheight="60px">
          $19.95
        </h2>
        <p>
          <sup>
            USD
            <br>
            /mo
          </sup>
        </p>
      </div>
      <div class="fusion-title-3 title">
        <div>
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
        <span class="awb-title-spacer"></span>
        <h2 class="fusion-title-heading title-heading-center"
            style="margin:0;font-size:1em;--fontSize:35;line-height:1.14;">
          Silver
        </h2>
        <span class="awb-title-spacer"></span>
        <div class="title-sep-container title-sep-container-right">
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
      </div>
      <div class="features fusion-text-5">
        <ul>
          <li>
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color-hover);">
              Each
              subscriber simultaneously shares same documents with (1) administrator and/or (1) associate.
            </span>
          </li>
          <li>
            Unlimited number of consultants &amp; experts.
          </li>
          <li>
            Unlimited DICOM image disc upload and Cloud storage (medical imaging studies)
          </li>
          <li>
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color-hover);">
              Unlimited
              Zoom Video conference time /session.
            </span>
          </li>
          <li>
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color);">
              2TB
              storage/month
            </span>
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color); color: #ba0000;">
              **
            </span>
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color);">
              (overage &#64; $0.20/GB/month).
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="plan-container"
       fxFlex="20">
    <div>
      <div id="gold"
           class="fusion-text-6 price">
        <h2 style="--fontSize: 40; line-height: 1.5;"
            data-fontsize="40"
            data-lineheight="60px">
          $24.95
        </h2>
        <p>
          <sup>
            USD
            <br>
            /mo
          </sup>
        </p>
      </div>
      <div class="fusion-title-4 title">
        <div>
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
        <span class="awb-title-spacer"></span>
        <h2 class="fusion-title-heading title-heading-center"
            style="margin:0;font-size:1em;--fontSize:35;line-height:1.14;">
          Gold
        </h2>
        <span class="awb-title-spacer"></span>
        <div class="title-sep-container title-sep-container-right">
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
      </div>
      <div class="features fusion-text-7 fusion-text-no-margin">
        <ul>
          <li>
            <b>
              Silver features
            </b>
            <strong>
              +
            </strong>
          </li>
          <li>
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color-hover);">
              Add
              one additional user (associate or administrator).
            </span>
          </li>
          <li>
            4TB storage/month
            <span style="color: #ba0000;">
              **
            </span>
            (overage &#64; $0.20/GB/month).
          </li>
          <li>
            Video conference recording and storage.
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="most-popular plan-container"
       fxFlex="20">
    <div>
      <div id="platinum"
           class="fusion-text-8 price">
        <h2 style="--fontSize: 40; line-height: 1.5;"
            data-fontsize="40"
            data-lineheight="60px">
          $39.95
        </h2>
        <p>
          <sup>
            USD
            <br>
            /mo
          </sup>
        </p>
      </div>
      <div class="fusion-title-5 title">
        <div>
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
        <span class="awb-title-spacer"></span>
        <h2 class="fusion-title-heading title-heading-center"
            style="margin:0;font-size:1em;--fontSize:35;line-height:1.14;">
          Platinum
        </h2>
        <span class="awb-title-spacer"></span>
        <div class="title-sep-container-right">
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
      </div>
      <div class="features fusion-text-9 fusion-text-no-margin">
        <ul>
          <li aria-level="1">
            <b>
              Gold features +
            </b>
          </li>
          <li aria-level="1">
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color-hover);">
              Add
              UNLIMITED additional users (associates and/or administrators).
            </span>
          </li>
          <li aria-level="1">
            5TB storage/month
            <span style="color: #ce0000;">
              **
            </span>
            (overage &#64; $0.15/GB/month).
          </li>
          <li aria-level="1">
            Remote Client upload for documents and discs
            <span style="color: #0096ed;">
              *
            </span>
            (available soon at no extra charge) .
          </li>
          <li aria-level="1">
            <b>
              Download DICOM (duplicate medical imaging discs)
            </b>
            allows you tu burn additional
            discs.
          </li>
          <li aria-level="1">
            Voice recognition input
            <span style="color: #00afef;">
              *
            </span>
            (available soon at no extra
            charge).
          </li>
          <li aria-level="1">
            Zoom video conference transcription
            <span style="color: #009cea;">
              *
            </span>
            (available soon
            at no extra charge).
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="most-popular plan-container"
       fxFlex="20">
    <div>
      <div id="lpmp"
           class="price">
        <h2 style="--fontSize: 40; line-height: 1.5;"
            data-fontsize="40"
            data-lineheight="60px">
          $35.00
        </h2>
        <p>
          <sup>
            USD
            <br>
            /mo
          </sup>
        </p>
      </div>
      <div class="title">
        <div>
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
        <span class="awb-title-spacer"></span>
        <h2 class="fusion-title-heading title-heading-center"
            style="margin:0;font-size:1em;--fontSize:35;line-height:1.14;">
          Clio Platinum
        </h2>
        <span class="awb-title-spacer"></span>
        <div class="title-sep-container title-sep-container-right">
          <div class="sep- sep-solid title-sep"
               style="border-color:#e0dede;"></div>
        </div>
      </div>
      <div class="features features-01 fusion-text-11">
        <ul>
          <li aria-level="1">
            <b>
              Gold features +
            </b>
          </li>
          <li aria-level="1">
            <span style="font-size: var(--awb-font-size); font-style: var(--awb-text-font-style); font-weight: var(--awb-text-font-weight); letter-spacing: var(--awb-letter-spacing); text-align: var(--awb-content-alignment); text-transform: var(--awb-text-transform); background-color: var(--awb-bg-color-hover);">
              Add
              UNLIMITED additional users (associates and/or administrators).
            </span>
          </li>
          <li aria-level="1">
            5TB storage/month
            <span style="color: #ce0000;">
              **
            </span>
            (overage &#64; $0.15/GB/month).
          </li>
          <li aria-level="1">
            Remote Client upload for documents and discs
            <span style="color: #0096ed;">
              *
            </span>
            (available soon at no extra charge) .
          </li>
          <li aria-level="1">
            <b>
              Download DICOM (duplicate medical imaging discs)
            </b>
            allows you tu burn additional
            discs.
          </li>
          <li aria-level="1">
            Voice recognition input
            <span style="color: #00afef;">
              *
            </span>
            (available soon at no extra
            charge).
          </li>
          <li aria-level="1">
            Zoom video conference transcription
            <span style="color: #009cea;">
              *
            </span>
            (available soon
            at no extra charge).
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
